import type { TableUrlState } from "./components/datatable/types/data-table";

export const MIN_NAME_LENGTH = 3;
export const MAX_NAME_LENGTH = 20;

export const MIN_TEXT_LENGTH = 0;
export const MAX_TEXT_LENGTH = 255;

export const MONEY_DECIMALS = 2;
export const WEIGHT_DECIMALS = 3;
export const KARAT_DECIMALS = 1;
export const SILVER_WEIGHT_RATIO = 0.12;

export const KARAT_DIFF_MARGIN = 1;

export const ROW_HEIGHT = 48;

export const ALLOWED_EMAIL_DOMAINS = [
  "gmail.com",
  "yahoo.com",
  "outlook.com",
  "hotmail.com",
  "icloud.com",
];

export const PAGE_SIZE = [10, 20, 30, 40, 50];

export const MIN_PAGE_SIZE = 10;
export const MAX_PAGE_SIZE = 50;

export const defaultTableState: TableUrlState = {
  sorting: [],
  columnFilters: [],
  globalFilter: "",
  pagination: { cursor: null, pageSize: MIN_PAGE_SIZE, cursorHistory: [] },
  showDeleted: false,
} as const;
